import { UserRole } from 'src/reducers/userReducer';
import { IDateRange } from '../../reducers/filtersReducer';

export enum AdminActivityAction {
  TransactionCreated = 'TRANSACTION_CREATED',
  CustomerDetailsUpdated = 'CUSTOMER_DETAILS_UPDATED',
  CustomerPasswordUpdated = 'CUSTOMER_PASSWORD_UPDATED',
  CustomerStatusUpdated = 'CUSTOMER_STATUS_UPDATED',
  LeadDetailsUpdated = 'LEAD_DETAILS_UPDATED',
  LeadReassigned = 'LEAD_REASSIGNED',
  EmailSent = 'EMAIL_SENT',
  CommentAddedToCustomer = 'COMMENT_ADDED_TO_CUSTOMER',
  CommentAddedToLead = 'COMMENT_ADDED_TO_LEAD',
  InstrumentCreated = 'INSTRUMENT_CREATED',
  InstrumentUpdated = 'INSTRUMENT_UPDATED',
  InstrumentDeleted = 'INSTRUMENT_DELETED',
  CurrencyConversionCreated = 'CURRENCY_CONVERSION_CREATED',
  CurrencyConversionUpdated = 'CURRENCY_CONCERSION_UPDATED',
  CurrencyConversionDeleted = 'CURRENCY_CONVERSION_DELETED',
  CustomerPositionCreated = 'CUSTOMER_POSITION_CREATED',
  CommissionPayoutApproved = 'COMMISSION_PAYOUT_APPROVED',
  CommissionPayoutRejected = 'COMMISSION_PAYOUT_REJECTED',
  CommissionRecordUpdated = 'COMMISSION_RECORD_UPDATED',
  PropTradingWalletCreated = 'PROP_TRADING_WALLET_CREATED',
  PropTradingChallengeCreated = 'PROP_TRADING_CHALLENGE_CREATED',
  CustomersBulkUpdated = 'CUSTOMERS_BULK_UPDATED',
  CustomerSecurityLevelUpdated = 'CUSTOMER_SECURITY_LEVEL_UPDATED',
  PaymentProviderUpdated = 'PAYMENT_PROVIDER_UPDATED',
  AutologinLinkGenerated = 'AUTOLOGIN_LINK_GENERATED',
  DepositLinkSentViaSms = 'DEPOSIT_LINK_SENT_VIA_SMS',
  RolePermissionsUpdated = 'ROLE_PERMISSIONS_UPDATED',
}

export interface IAuditLogsFiltersDTO {
  actions: Array<string>;
  createdAt: IDateRange | undefined;
  actedAs: UserRole | undefined;
  types: Array<string>;
}

export enum AffectedObjectType {
  Lead = 'LEAD',
  Customer = 'CUSTOMER',
  Role = 'ROLE',
  Instrument = 'INSTRUMENT',
  CurrencyConversion = 'CURRENCY_CONVERSION',
  Order = 'ORDER',
  Position = 'POSITION',
  PropTrading = 'PROPTRADING',
  Wallet = 'WALLET',
  ChallengeType = 'CHALLENGE_TYPE',
  FundedAccountType = 'FUNDED_ACCOUNT_TYPE',
  PropFunnel = 'PROP_FUNNEL',
  Customers = 'CUSTOMERS',
  Transaction = 'TRANSACTION',
  PaymentProvider = 'PAYMENT_PROVIDER',
}

export interface IAdminActivity {
  id: string;
  actingCustomerId: string;
  actingCustomerName: string;
  action: AdminActivityAction;
  createdAt: Date;
  role: UserRole;
  type: AffectedObjectType;
  displayName: string;
  affectedObjectId: string;
  affectedObjectFound: boolean;
}

export interface IActivityQuery {
  activities: Array<IAdminActivity>;
  count: number;
}
